import { Translations } from '../config/translations';
import { View } from './view';

export class PayPalView extends View {

    addPaypalButton() {
        const form = document.createElement('div');
        form.setAttribute('id', 'paypal-form-block');
        form.classList.add('hs-form', 'stacked', 'df-f', 'df-f-paypal');

        const button = document.createElement('input');
        button.setAttribute('id', 'df-pay-pal-button');
        button.setAttribute('type', 'submit');
        button.setAttribute('class', 'hs-button primary large df-pay-btn df-input');
        button.setAttribute('data-label', 'pay_with_paypal');
        button.setAttribute('value', Translations.PAY_WITH_PAYPAL);
        button.style.margin = '0';
        form.appendChild(button);

        const errorField = document.createElement('div');
        errorField.classList.add('form-columns-1', 'df-field');
        errorField.innerHTML = `<fieldset class='form-columns-1 df-fieldset'><label class='error' id='paypal_error'></label></fieldset>`;
        form.appendChild(errorField);

        const container = this.getDFContainer();
        container.appendChild(form);
    }

    createPayPalForm(config: any[], action: any) {
        const form = document.createElement('form');
        form.setAttribute('action', action);
        form.setAttribute('method', 'post');
        form.setAttribute('id', 'df_paypalform');
        form.setAttribute('target', '_parent');
        config.forEach((configElement: any) => {
            if (configElement.name) {
                const input = document.createElement('input');
                input.setAttribute('type', 'hidden');
                input.setAttribute('name', configElement.name || '');
                input.setAttribute('value', configElement.value || '');
                if (configElement.id) {
                    input.setAttribute('id', configElement.id || '');
                }
                form.appendChild(input);
            }
        });
        const container = this.getDFContainer();
        container.appendChild(form);
    }

    deletePayPalForm() {
        const form = document.querySelector('#df_paypalform');
        if (form) {
            form.remove();
        }
    }

    setVisible(isActive: boolean) {
        const form = this.getHtmlElement('#paypal-form-block');
        if (!form) {
            return;
        }
        if (isActive) {
            this.show(form);
        } else {
            this.hide(form);
        }
    }

}
